"use client";

import React from 'react';
import { useRouter } from 'next/navigation';
import PortalEntry from '@/components/PortalEntry';

export default function LoginPage() {
    const router = useRouter();

    return (
        <main className="h-screen w-full bg-background relative overflow-hidden">
            <PortalEntry onEnter={() => {
                router.push('/dashboard');
            }} />
        </main>
    );
}
